import { tsValidateExists, tsValidateResult } from '@nu-art/ts-common';
import { smartDocStaticParamType_Attribute, Validator_SmartDocStaticParam_Attribute } from './attribute/index.js';
import { smartDocStaticParamType_Factor, Validator_SmartDocStaticParam_Factor } from './factor/index.js';
import { smartDocStaticParamType_Tag, Validator_SmartDocStaticParam_Tag } from './tag/index.js';
import { smartDocStaticParamType_Finding, Validator_SmartDocStaticParam_Finding } from './finding/index.js';
import { smartDocStaticParamType_ChiefComplaint, Validator_SmartDocStaticParam_ChiefComplaint } from './chief-complaint/index.js';
import { smartDocStaticParamType_ContextRule, smartDocStaticParamType_MDM, smartDocStaticParamType_Orders, smartDocStaticParamType_PhysicianNotes } from './types.js';
import { smartDocStaticParamType_Template, Validator_SmartDocStaticParam_Template } from './template/index.js';
import { smartDocParamType_Static } from './_base/index.js';
import { Validator_SmartDocStaticParam_Orders } from './orders/index.js';
import { Validator_SmartDocStaticParam_PhysicianNotes } from './physician-notes/index.js';
import { Validator_SmartDocStaticParam_MDM } from './mdm/index.js';
import { Validator_SmartDocStaticParam_ContextRule } from './context-rule/index.js';
import { smartDocStaticParamType_SmartMDM, Validator_SmartDocStaticParam_SmartMDM } from './smart-mdm/index.js';
import { smartDocStaticParamType_Time, Validator_SmartDocStaticParam_Time } from './time/index.js';
export const Validator_SmartDocStaticParam = (param, parent) => {
    //If the log template parent isn't passed
    if (!parent)
        return 'Can not validate static log template parameter without the log template';
    //If the param is unavailable
    if (!param)
        return tsValidateResult(param, tsValidateExists());
    switch (param.subType) {
        case smartDocStaticParamType_Tag:
            return tsValidateResult(param, Validator_SmartDocStaticParam_Tag);
        case smartDocStaticParamType_Finding:
            return tsValidateResult(param, Validator_SmartDocStaticParam_Finding);
        case smartDocStaticParamType_ChiefComplaint:
            return tsValidateResult(param, Validator_SmartDocStaticParam_ChiefComplaint);
        case smartDocStaticParamType_Attribute: {
            return assertParentParamExists(param.parentKey, parent) ?? tsValidateResult(param, Validator_SmartDocStaticParam_Attribute);
        }
        case smartDocStaticParamType_Factor:
            return assertParentParamExists(param.parentKey, parent) ?? tsValidateResult(param, Validator_SmartDocStaticParam_Factor);
        case smartDocStaticParamType_Template:
            return tsValidateResult(param, Validator_SmartDocStaticParam_Template);
        case smartDocStaticParamType_Orders:
            return tsValidateResult(param, Validator_SmartDocStaticParam_Orders);
        case smartDocStaticParamType_PhysicianNotes:
            return tsValidateResult(param, Validator_SmartDocStaticParam_PhysicianNotes);
        case smartDocStaticParamType_MDM:
            return tsValidateResult(param, Validator_SmartDocStaticParam_MDM);
        case smartDocStaticParamType_ContextRule:
            return tsValidateResult(param, Validator_SmartDocStaticParam_ContextRule);
        case smartDocStaticParamType_SmartMDM:
            return tsValidateResult(param, Validator_SmartDocStaticParam_SmartMDM);
        case smartDocStaticParamType_Time:
            return tsValidateResult(param, Validator_SmartDocStaticParam_Time);
        default: {
            // @ts-ignore
            return { subType: param.subType ? `Unknown param subType ${param.subType}` : `Missing mandatory field subType` };
        }
    }
};
//Validate that a static parameter exists with a key matching the param.parentKey for params that need it
const assertParentParamExists = (key, params) => {
    if (!key)
        return;
    const parentParam = params.find(param => param.type === smartDocParamType_Static && param.key === key);
    if (!parentParam)
        return { parentKey: 'Parent key not connected to an actual param', };
};
//# sourceMappingURL=validation.js.map